import React, { Component } from 'react';

import styles from './styles.m.scss';

import { routes } from '../../routes';

class Footer extends Component {
  render() {
    return (
      <footer className="d-print-none">
        <div className={styles.copyright}>
          <div className="container">
            <p>
              © Sage Financial Solutions
              <sup>®</sup>. All Rights Reserved. Please review our{' '}
              <a href={routes.wordPress.termsOfUse}>Terms of Use,</a>
              &nbsp;
              <a href={routes.wordPress.bylaws}>Bylaws,</a> and{' '}
              <a href={routes.wordPress.privacyPolicy}>Privacy Policy.</a>
            </p>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
